import { Box } from '@mui/material';

import { Roles } from '~/data/user';
import { useSelectedEmployeeId } from '~/hooks/employee';
import { employeeModulesAccessRoles } from '~/scenes/PortalViews/Views/EmployeeViews/data';

import { EmergencyContact } from './components/EmergencyContact/component';
import { HomeContact } from './components/HomeContact/component';
import { OtherContact } from './components/OtherContact/component';
import { WorkContact } from './components/WorkContact/component';
import { useSxStyles } from './useStyles';

export const ContactTab = () => {
  const sxStyles = useSxStyles();
  const {
    isSelectedEmployeeLoggedInUser,
    selectedEmployeeDetails: { hasRoleAccessOverEmployee },
  } = useSelectedEmployeeId();
  const restrictHomeContactView =
    hasRoleAccessOverEmployee(
      [Roles.MANAGER, Roles.ALT_MANAGER, Roles.DEPUTY_MANAGER],
      employeeModulesAccessRoles.people.all,
    ) && !isSelectedEmployeeLoggedInUser;

  return (
    <Box sx={sxStyles.tabContent}>
      <Box sx={sxStyles.sfSection}>
        <WorkContact />
      </Box>
      {!restrictHomeContactView && (
        <Box sx={sxStyles.sfSection}>
          <HomeContact />
        </Box>
      )}
      <Box sx={sxStyles.sfSection}>
        <EmergencyContact />
      </Box>
      <Box sx={sxStyles.sfSection}>
        <OtherContact />
      </Box>
    </Box>
  );
};
